import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  baseUrl: '',
  logLevel: NgxLoggerLevel.DEBUG,
  serverLogLevel: NgxLoggerLevel.INFO
};
